import { Client } from '../pages/Clients/interfaces';
import { applyThousandsSeparator } from '../utils/strings';

export const getAvailableBalance = (selectedClient: Client) => {
  const balance = selectedClient.balance?.availableQuota;
  return applyThousandsSeparator(balance);
};